import cn from '../styles.module.css';

interface BaseStatisticItemProps {
  title: string;
  value: string;
}

const BaseStatisticItem = ({
  title,
  value,
}: BaseStatisticItemProps): React.JSX.Element => (
  <div className={cn.baseStatisticItem}>
    <div className={cn.baseStatisticItemTitle}>{title}</div>
    <div className={cn.baseStatisticItemValue}>{value}</div>
  </div>
);

export default BaseStatisticItem;
